import React from "react"
import PropTypes from "prop-types"
import { Section, CmsImage } from "@bw/bits"
import { Teasers } from "@bw/modules"
import { Teaser } from "@bw/partials"
import dateFormat from "../../../utils/dateFormat"

const Events = ({ events }) => {
  if (!events) {
    return null
  }

  return (
    <Section>
      <Teasers>
        {events.map((item, k) => (
          <Teaser
            key={k}
            title={item.title}
            suptitle={item.getStartDate()}
            excerpt={item.teaserExcerpt}
            image={
              <CmsImage
                src={item.teaserImage || "/placeholder-teaser.jpg"}
                alt={item.title}
              />
            }
            to={item.slug}
          />
        ))}
      </Teasers>
    </Section>
  )
}

Events.propTypes = {
  events: PropTypes.array,
}

export { Events }
